export default __webpack_public_path__ + "static/media/detail_mobile_1_3.3eff91d7.png";